import { ApiConfig } from "../config/api.config";
import { TemplateConfig } from "../model/template-config.model";
import apiService from "./api.service";

const getInfoByMediaId = (mediaId: string) => {
    const url = ApiConfig.info.getByMediaId.replace('{id}', mediaId);
    return apiService.get(url);
}

const getInfoById = (mediaId: string, id: string) => {
    const url = ApiConfig.info.getById.replace('{mediaId}', mediaId).replace('{id}', id);
    return apiService.get(url);
}

const addInfo = (mediaId: string, template_id: number, size: string, title: string, focus_speaker: number[], tone: string, block: any, block_max_quote_char: number, block_max_title_char: number) => {
    const url = ApiConfig.info.add.replace('{mediaId}', mediaId);
    const data = {
        template_config: { template_id, size, title, focus_speaker, tone, block, block_max_quote_char, block_max_title_char }
    };
    return apiService.post(url, data);
}

const updateInfo = (mediaId: string, id: string, template_config: TemplateConfig, raw_images: string[], full_image: string, thumbnail_image: string, text_config: any) => {
    const url = ApiConfig.info.update.replace('{mediaId}', mediaId).replace('{id}', id);
    const data = {
        template_config,
        raw_images,
        text_config,
        ...(full_image && { full_image }),
        ...(thumbnail_image && { thumbnail_image })
    };
    return apiService.put(url, data);
}

const deleteInfo = (mediaId: string, id: string) => {
    const url = ApiConfig.info.delete.replace('{mediaId}', mediaId).replace('{id}', id);
    return apiService.delete(url);
}

const getInfographic = (mediaId: string, id: string) => {
    const url = ApiConfig.info.getInfographic.replace('{mediaId}', mediaId).replace('{id}', id);
    return apiService.post(url);
}

const getSummary = (mediaId: string, id: string) => {
    const url = ApiConfig.info.getSummary.replace('{mediaId}', mediaId).replace('{id}', id);
    return apiService.post(url);
}

const checkSpelling = (html: string) => {
    const data = { html };
    return apiService.post(ApiConfig.info.checkSpelling, data);
}

const InfographicService = {
    getInfoByMediaId,
    getInfoById,
    addInfo,
    updateInfo,
    deleteInfo,
    getInfographic,
    getSummary,
    checkSpelling,
};

export default InfographicService;